export default __webpack_public_path__ + "static/media/icon_8.91ea196c.png";